<template>
  <table style="width:100%;">

    <th
      v-for="(item, key) in headLabels"
      :key="key">
      {{ item.label }}
    </th>
    <tr
      v-for="(item, key) in tableData"
      :key="key"
      class="tr">

      <td data-col-seq="1">
        {{ key+1 }}
      </td>

      <td data-col-seq="2">
        {{ item.prijmy }}
      </td>

      <td data-col-seq="2">
        {{ item.odvody }}
      </td>

      <td data-col-seq="2">
        {{ item.zdroj }}
      </td>
    </tr>
    <tfoot>
      <tr>
        <td>Spolu</td>
        <td data-col-seq="2">
          {{ footData.prijmy }}
        </td>

        <td data-col-seq="2">
          {{ footData.odvody }}
        </td>
      </tr>
    </tfoot>

  </table>
</template>

<script>
export default {

  props: {
    headLabels: {
      type: Object,
      default: null,
      required: false,
    },
    tableData: {
      type: Array,
      default: null,
      required: true,
    },
    footData: {
      type: Object,
      default: null,
      required: false,
    },
  },

};
</script>
